import Vue from 'vue'
import Router from 'vue-router'

import Main from '@/components/Main'
import Login from '@/components/Login'
import ForgotPassword from '@/components/ForgotPassword'
import ResetPassword from '@/components/ResetPassword'
import FourOhFour from '@/components/404'
import About from '@/components/About'
import Galaxy from '@/components/Galaxy'
import ToDo from '@/components/ToDo'
import Account from '@/components/Account'
import Email from '@/components/Email'
import TheLibrary from '@/components/TheLibrary'

import AdminUpload from '@/components/admin/Upload'
import AdminReset from '@/components/admin/Reset'

Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'Main',
      component: Main
    },
    {
      path: '/login',
      name: 'Login',
      component: Login
    },
    {
      path: '/forgot',
      name: 'Forgot Password',
      component: ForgotPassword
    },
    {
      path: '/reset',
      name: 'Reset',
      component: ResetPassword,
      props: true
    },
    {
      path: '/:comicId(\\d+)',
      name: 'Archive',
      component: Main,
      props: true
    },
    {
      path: '/about',
      name: 'About',
      component: About
    },
    {
      path: '/galaxy',
      name: 'Galaxy',
      component: Galaxy
    },
    {
      path: '/todo',
      name: 'To-Do',
      component: ToDo
    },
    {
      path: '/account',
      name: 'Account',
      component: Account
    },
    {
      path: '/email',
      name: 'Email',
      component: Email
    },
    {
      path: '/upload',
      name: 'AdminUpload',
      component: AdminUpload
    },
    {
      path: '/adminreset',
      name: 'AdminReset',
      component: AdminReset
    },
    {
      path: '/thelibrary',
      name: 'Library',
      component: TheLibrary
    },
    {
      path: '*',
      name: '404',
      component: FourOhFour
    }
  ],
  scrollBehavior (to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      if (to.name === 'Archive') {
        const contentTop = document.getElementById('content-top').offsetTop + 50 // magic
        return { x: 0, y: contentTop || 0 }
      }
      return { x: 0, y: 0 }
    }
  }
})



// WEBPACK FOOTER //
// ./src/router/index.js